function getUserByToken({ input, output, services }) {
  services.Http
    .post('/api/user/get/token', { token: input.token })
    .then(output.success)
    .catch(output.error)
}

getUserByToken.async = true
getUserByToken.outputs = ['success', 'error']

export default getUserByToken



// WEBPACK FOOTER //
// ./src/modules/login/actions/getUserByToken.js